import { render, staticRenderFns } from "./LbaDialogEdit.vue?vue&type=template&id=45014c5a"
import script from "./LbaDialogEdit.vue?vue&type=script&lang=js"
export * from "./LbaDialogEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports